import React, { useEffect } from 'react'
import { pluralize } from '../../../utils/textHelpers'

const enableSelectpickerPaste = () => {
  window.$('select.selectpicker').on('loaded.bs.select', selectElement => {
    window.$(selectElement.target).parent()
      .find('.bs-searchbox')
      .find('input')[0]
      .onpaste = event => {
        const clipboardData = event.clipboardData.getData('text')
        const splitStr = clipboardData.includes('\r\n') ? '\r\n' : '\n'
        const paste = clipboardData.split(splitStr)
        const newValues = []
        const options = Array.from(selectElement.target.options)
        paste.forEach(pasteElement => {
          options.forEach(option => {
            if (pasteElement.toUpperCase() === option.text.toUpperCase())
              newValues.push(option.value)
          })
        })
        const previousValues = Array.from(selectElement.target.selectedOptions, option => option.value)
        window.$(selectElement.target).selectpicker('val', newValues.concat(previousValues))
        window.$(selectElement.target).selectpicker('render')
      }
  })
}

const applySelectedCountLabel = select => {
  const count = select.selectedOptions.length
  if (count === 0)
    return
  const wrapper = select.closest('.bootstrap-select')
  const label = wrapper && wrapper.querySelector('.filter-option-inner-inner')
  if (label)
    label.textContent = pluralize(count, 'sélectionné')
}

const byLabel = (first, second) => first.text.trim()
  .localeCompare(second.text.trim(), 'fr', { sensitivity: 'base' })

const reorderSelectedFirst = select => {
  select.querySelectorAll('optgroup').forEach(group => {
    const options = Array.from(group.children)
    const selected = options.filter(option => option.selected).sort(byLabel)
    const rest = options.filter(option => !option.selected).sort(byLabel)
    selected.concat(rest).forEach(option => group.appendChild(option))
  })
}

const SelectUserGroupField = ({
  name, label, data, value, onChange, multiple, countLabel = false, selectedFirst = false
}) => {
  useEffect(() => {
    const $select = window.$(`select[name="${name}"].selectpicker`)
    const [select] = $select

    if (select && countLabel) {
      $select
        .off('rendered.bs.select.countLabel')
        .on('rendered.bs.select.countLabel', () => applySelectedCountLabel(select))
    }
    if (select && selectedFirst) {
      $select
        .off('show.bs.select.selectedFirst')
        .on('show.bs.select.selectedFirst', () => {
          reorderSelectedFirst(select)
          $select.selectpicker('refresh')
        })
    }

    $select.selectpicker('render')
    if (select && countLabel)
      applySelectedCountLabel(select)
    enableSelectpickerPaste()
  })

  return (
    <div className="form-group">
      <label htmlFor={name}>{label}</label>
      <select
        className="form-control selectpicker"
        name={name}
        id={name}
        defaultValue={value}
        multiple={multiple}
        data-live-search="true"
        data-live-search-placeholder="Rechercher..."
        data-actions-box
        onChange={onChange}
      >
        {
          Object.keys(data).map((key, index) => (
            <optgroup key={index} label={key}>
              {data[key].map(item => (
                <option key={item.id} value={item.id}>
                  {`${item.last_name} ${item.first_name}`}
                </option>
              ))}
            </optgroup>
          ))
        }
      </select>
    </div>
  )
}

export default SelectUserGroupField
